export const PT_INDEX = "/";
export const PT_STARTUP = "/startup/:csp";
export const PT_LAND = "/land";
export const PT_SETTINGS = "/Settings";
export const PT_CONFIGURE = "/:csp";
export const PT_HOME = "/home";
export const PT_PRODUCT_LIST = "/product-list/:navPage/:isSec"; //is section
export const PT_QR_LIST = "/qr-list/:mid/:tableNo?";
export const PT_TYPE_LAND = "/typeLand";
export const PT_PROMO_PRODUCT_LIST = "/promo-product-list/:navPage";
export const PT_PRODUCT =
  "/product/:frompage/:navigatepage/:category/:pid/:lineid/:adonlineid/:isrecommended";
export const PT_FILTER_OUTLETS_PRODUCTS = "/:frmpath/filter";
export const PT_MASTERCATEGORY = "/category";
export const PT_CATEGORYWISE_MERCHANT = "/categorywisemerchant";

export const HOME_STACK_PATHS_CONTAIN_CHECK = (pathname) => {
  let firstPart = pathname.split("/").filter(Boolean)[0];
  let paths =
    // PT_LAND +
    PT_HOME +
    PT_PRODUCT_LIST +
    PT_QR_LIST +
    PT_PROMO_PRODUCT_LIST+
    PT_PRODUCT +
    PT_FILTER_OUTLETS_PRODUCTS +
    PT_MASTERCATEGORY +
    PT_CATEGORYWISE_MERCHANT;

  return paths.toUpperCase().includes(firstPart.toUpperCase());
};
